/**
 * LandingPage Template Component
 * Complete landing page template combining Header, Hero, sections, and Footer
 */

import React from 'react';
import { storyblokEditable, StoryblokComponent } from '@/lib/blocks';
import { Header } from '@/components/organisms/Header';
import { Hero } from '@/components/organisms/Hero';
import { Footer } from '@/components/organisms/Footer';
import type { LandingPageBlok } from '@/types';

// Map component types to anchor IDs for nav scrolling
const sectionIdMap: Record<string, string> = {
  feature_grid: 'features',
  value_proposition: 'value-proposition',
  benefit_grid: 'benefits',
  difference_section: 'how-it-works',
  logo_bar: 'clients',
  cta_banner: 'cta',
  app_suite_section: 'app-suite',
  pricing_section: 'prices',
  process_section: 'process',
};

export interface LandingPageProps {
  blok: LandingPageBlok;
}

export const LandingPage: React.FC<LandingPageProps> = ({ blok }) => {
  const {
    header,
    hero,
    sections,
    footer,
  } = blok;

  return (
    <div {...storyblokEditable(blok)} className="min-h-screen flex flex-col scroll-smooth bg-theme-bg text-theme-text">
      {/* Header */}
      {header && header[0] && (
        <Header blok={header[0]} />
      )}

      {/* Hero Section */}
      {hero && hero[0] && (
        <div id="about">
          <Hero blok={hero[0]} />
        </div>
      )}

      {/* Dynamic Sections */}
      {sections && sections.length > 0 && (
        <main className="flex-1">
          {sections.map((section) => (
            <div key={section._uid} id={sectionIdMap[section.component]}>
              <StoryblokComponent blok={section} />
            </div>
          ))}
        </main>
      )}

      {/* Footer */}
      {footer && footer[0] && (
        <Footer blok={footer[0]} />
      )}
    </div>
  );
};

export default LandingPage;
